import { useFormikContext, FormTextField, getIn } from 'components/Formik/forms'
import Grid from '@mui/material/Grid2'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import DegreeProgramSets from './DegreeProgramSets'

const LANDING_PAGE_RULE_ACTION_TYPES = {redirect: 'Redirect URL', exclude_programs: 'Exclude Programs'}

export default function ActionType({ path }) {
  const { values, setFieldValue } = useFormikContext()
  const landingPageRule = getIn(values, path)

  const handleRuleActionTypeSelect = event => {
    if(event.target.value !== 'redirect') {
      setFieldValue(`${path}.redirectUrl`, null)
    }
    setFieldValue(`${path}.actionType`, event.target.value)
  }

  return(
    <Grid container spacing={2}>
      <Grid size={{ xs: 4 }}>
        <TextField
          select
          value={landingPageRule.actionType || ''}
          onChange={handleRuleActionTypeSelect}
          label='Redirect or Exclude Programs'
          fullWidth
          id={`landing_page_rule_type_${Math.random()}`}
        >
          {Object.entries(LANDING_PAGE_RULE_ACTION_TYPES).map(([actionType, text]) => (
            <MenuItem value={actionType} key={`rule_question_${actionType}`}>{text}</MenuItem>
          ))}
        </TextField>
      </Grid>
      { landingPageRule.actionType === 'redirect' && (
        <Grid size={{ xs: 8 }}>
          <FormTextField
            name={`${path}.redirectUrl`}
            label='Redirect URL (leave blank to use default)'
            value={landingPageRule.redirectUrl || ''}
            fullWidth
            id={`landing_page_rule_operator_redirectUrl}`}
          />
        </Grid>
      )}
      { landingPageRule.actionType === 'exclude_programs' && (
        <DegreeProgramSets
          path={`${path}.degreeProgramSets`}
        />
      )}
    </Grid>
  )
}
